import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'antd';
import { useEffect, useState } from 'react';
import { isNotNullUndefined } from '../helpers/common';
import { storage } from '../utils/storage';
import Images from '../assets/images';
import "../assets/css/login.css";

const LoginPage = () => {
    const { loginWithRedirect, user, isAuthenticated, isLoading, getAccessTokenSilently, getIdTokenClaims, error } = useAuth0();
    const navigate = useNavigate();

    const [isExecuting, setExecuting] = useState(false);

    useEffect(() => {
        const getToken = async () => {
            if (isAuthenticated && user?.ailtra_user_roles.includes("Admin")) {
                try {
                    const accessToken = await getAccessTokenSilently();
                    const claims = await getIdTokenClaims();
                    const idToken = claims?.__raw ?? "";
                    setExecuting(true);
                    storage.setAccessToken(accessToken);
                    storage.setIdToken(idToken);
                    storage.setUserName(user?.name ?? "");
                    storage.setUserEmail(user?.email ?? "");
                    storage.setUserProfilePicture(user?.picture ?? "");
                    storage.setLocalProperty("isAuthenticated", true);
                    navigate("/appconfiguration");
                    return;
                } catch (error) {
                    console.error('❌ Error getting token:', error);
                }
            }
            else if ((isNotNullUndefined(error) || isNotNullUndefined(user)) && !user?.ailtra_user_roles.includes("Admin")) {
                const isUnAuthorized = !user?.ailtra_user_roles?.includes("Admin");
                const isBlocked = ((error?.message ?? "") !== "");
                storage.setLocalProperty("isUnAuthorized", isUnAuthorized);
                storage.setLocalProperty("isBlocked", isBlocked);

                if (isUnAuthorized || isBlocked) {
                    navigate("/unauthorized");
                }
            }
        };

        getToken();
    });

    if (isLoading || isExecuting) {
        return (
            <div className="login-loading">
                <div className="loading-spinner"></div>
                <p className="loading-text">Redirecting...</p>
            </div>
        )
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-title">
                    Login to Ailtra Bot 👋
                </div>
                <p className="login-subtitle">
                    Click <strong>Secure Login</strong> to continue. Authentication will be handled by Auth0.
                </p>

                <Form name="login" className="login-form" initialValues={{ remember: true }}>
                    <Form.Item>
                        {!isAuthenticated ? (
                            <Button
                                type="primary"
                                htmlType="submit"
                                onClick={() => loginWithRedirect({ appState: { returnTo: window.location.pathname } })}
                                className="secure-button"
                            >
                                <img
                                    src={Images.security}
                                    className="secure-icon"
                                    alt="secure-logo"
                                />
                                Secure Login
                            </Button>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                <p>Welcome back! Redirecting...</p>
                            </div>
                        )}
                    </Form.Item>
                </Form>
            </div>

            <div className="login-footer">
                © Copyright 2016 - {new Date().getFullYear()} | All Rights Reserved.
            </div>
        </div>
    );

};
export default LoginPage;